/* eslint-disable import/prefer-default-export */
export const current = (state) => (state.currentLocale);
